module.exports = __webpack_public_path__ + "static/img/RSG2-24V10A.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RSG2-24V10A.png
// module id = BAn5
// module chunks = 0